<template>
<v-container>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <div v-if="isEntry" style="text-align: center;">
      <h4 class="teal--text ">エントリー済みです</h4>
      </div>
      <v-card  class="black--text display-2s">
            <v-card-title primary-title class="ah-tournament-lead">

              <div class="headline"><div v-html="item.title"></div></div>
              <div class="red--text" v-if="item.endTime <  new Date()">受付終了</div>
              <div class="red--text" v-if="item.endTime >  new Date()">あと残り{{item.remaining}}チーム</div>
            </v-card-title>
      </v-card>
      <v-card>
        <!--
        <v-card-media src="/static/9.jpg" height="280px">
          <v-layout column class="media">
            <v-card-title class="white--text pl-5 pt-5">
              <div class="display-1 pl-5 pt-5">{{item.title}}</div>
            </v-card-title>
          </v-layout>
        </v-card-media>
        -->
        <v-list >

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">event</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{item.startTime | dateformat}} </v-list-tile-title>
            </v-list-tile-content>

          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">location_on</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
              {{item.location}}
              </v-list-tile-title>
              <v-list-tile-title>
              <div class="caption">{{item.address}}</div>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        <v-divider inset></v-divider>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">payment</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-if="item.entryFee">参加費：¥ {{item.entryFee.toLocaleString()}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">group</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{item.capacity}}チーム募集
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

        </v-list>
      </v-card>

      <h5 class="mt-3 mb-0">詳細</h5>
      <p v-html="item.subTitle"></p>
      <p v-html="item.info"></p>
      <div class="ggmap">
        <iframe v-if="item.location == '南長崎スポーツセンター'" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12956.232516014641!2d139.6832012!3d35.7247889!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8a27deea799a5cd7!2z5Y2X6ZW35bSO44K544Od44O844OE44K744Oz44K_44O8!5e0!3m2!1sja!2sjp!4v1517322640291" width="600" height="550" frameborder="0" style="border:0" allowfullscreen></iframe>
        <iframe v-if="item.location == '品川区総合体育館'" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3243.143854391381!2d139.72607431548823!3d35.6241799802077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188af769b23af9%3A0x5eceea4ed39b40f7!2z5ZOB5bed5Yy657eP5ZCI5L2T6IKy6aSo!5e0!3m2!1sja!2sjp!4v1522681830305" width="600" height="550" frameborder="0" style="border:0" allowfullscreen></iframe>
      </div>



       <v-list v-if="false" two-line>
      <template v-for="item in teams">
        <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
        <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
        <v-list-tile avatar v-else v-bind:key="item.title" :to="item.to">
          <v-list-tile-avatar>
            <img v-if="item.avatar" v-bind:src="item.avatar">
            <img v-else v-bind:src="defaultTeamAvatar">
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-html="item.teamName"></v-list-tile-title>
            <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
        </v-list>



      <div v-if="item.endTime >  new Date()">
        <v-btn v-if="!isEntry && item.remaining > 0" block secondary green :to="this.to">エントリーに進む</v-btn>
        <div v-else-if="isEntry" style="text-align: center;">
          <h4 class="teal--text ">エントリー済みです</h4>
        </div>
        <div v-if="item.remaining == 0" class="red--text">満員です</div>
      </div>

      <div v-if="item.endTime <  new Date()">
        <v-btn v-if="!isEntry && item.remaining > 0" block secondary green :to="this.to" disabled="">受付終了</v-btn>
      </div>

    </v-flex>
  </v-layout>
</v-container>
</template>



<script>
import firebase from 'firebase'

export default {
  title () {
    return '大会詳細'
    // this.item.title
  },
  components: {
    firebase
  },
  data () {
    return {
      // title: this.item.title,
      defaultTeamAvatar: '/static/defaultteam.png',
      teams: [{ header: '参加チーム' }],
      // remaining: this.item.capacity - this.teams.length,
      item: Object,
      to: '/user/profile',
      cancelto: null,
      joiningTemas: [],
      isEntry: false
    }
  },
  created () {
    // select tournament
    var db = firebase.firestore()

    var docRef = db.collection('tournaments').doc(this.$route.params.id)
    // Read the document.
    docRef.get().then(doc => {
      if (doc.exists) {
        // Document read successfully.
        this.item = doc.data()
        this.entries()
      } else {
        console.log('No such document!')
      }
    }).catch(function (error) {
      console.log('Error getting document:', error)
    })
    //

     // this.remaining = this.item.capacity - this.teams.length
  },
  methods: {
    update: function () {
      //
      this.email = null
    },

    init: function () {
//      var db = firebase.firestore()
    },

    entries: function () {
      var db = firebase.firestore()
      this.getTeamByUser()
      let query = db.collection('entries').where('tournament', '==', this.$route.params.id)
      query.get().then(querySnapshot => {
        querySnapshot.forEach(documentSnapshot => {
          var obj = documentSnapshot.data()
          this.getTeam(obj.team).then(doc2 => {
            if (doc2) {
              obj.teamName = doc2.teamName
              this.teams.push(obj)
              // is entry
              if (this.joiningTemas.includes(obj.team)) {
                this.isEntry = true
              }
            }
          })
        })
      })
    },
    tournaments: function () {
      var db = firebase.firestore()
      db.collection('tournaments').get()
    },
    getTeam: function (id) {
      return new Promise((resolve, reject) => {
      //
        var db = firebase.firestore()
        var docRef = db.collection('teams').doc(id)

        // Read the document.
        docRef.get().then(doc => {
          if (doc.exists) {
            // Document read successfully.
            resolve(doc.data())
          } else {
            console.log('No such document!')
          }
        }).catch(function (error) {
          console.log('Error getting document:', error)
        })
      //
      })
    },
    getTeamByUser: function () {
      return new Promise((resolve, reject) => {
      //
        let user = firebase.auth().currentUser
        if (!user) {
          return
        }
        var db = firebase.firestore()
        var query = db.collection('m2m_teams_users').where('user', '==', user.uid)
        // Read the document.
        query.get().then(querySnapshot => {
          querySnapshot.forEach(documentSnapshot => {
            var obj = documentSnapshot.data()
            if (obj) {
              this.joiningTemas.push(obj.team)
              this.to = '/tournamentconfirm/' + this.$route.params.id
            }
          })
        })
      //
      })
    }
  }
}
</script>





<style>
.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}

.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}

 .media {
    height: 100%;
    margin: 0;
 }

 .ah-tournament-lead {
   display:block;
 }
</style>



// WEBPACK FOOTER //
// src/components/tournament/TournamentDetail.vue